module.exports = __webpack_public_path__ + "89c63087fa34991d742d2a3382efe353.svg";